import {
  ICreateIRSRequest,
  IIdRequest,
} from "@/types/irs/idRequestType";
import { IProfile } from "@/types/irs/profileType";
import { IAddress } from "@/types/irs/addressType";

const tempWindow: any = window;
const irsSdk = tempWindow.irsSdk;

export const documentVerificationInit = async (req: IIdRequest) => {
  const response = await irsSdk?.init(req);
  return response;
}

export const initSdk = async (sessionId: any) => {
  await irsSdk?.initAlloySdk(sessionId);
}

export const createIRSApplication = async (req: ICreateIRSRequest) => {
  const addressList: IAddress[] = req.addresses?.map((address, index) => ({
    type: index === 0 ? "primary" : index === 1 ? "mailing" : "other",
    streetNumber: address.streetNumber,
    streetName: address.streetName,
    unitNumber: address.unitNumber,
    city: address.city,
    region: address.province,
    postalCode: address.postalCode,
    country: address.country,
  })) || [];

  const profile: IProfile = {
    nameFirst: req.applicant.firstName,
    nameLast: req.applicant.lastName,
    phoneNumber: req.applicant.phoneNumber,
    sin: req.applicant.sin,
    emailAddress: req.applicant.isProspect ? req.credential.email : req.applicant.email,
    birthDate: `${req.applicant.dob_year}-${req.applicant.dob_month}-${req.applicant.dob_day.padStart(2, '0')}`,
    addresses: addressList,
  };

  const idRequest: IIdRequest = {
    requestKey: import.meta.env.VITE_IRS_REQUEST_KEY,
    sessionId: req.applicant.alloySessionId,
    profiles: [profile],
    additionalData: req.additionalData || {},
  };

  return await irsSdk?.init(idRequest);
};

export const getIRSApplication = async (sessionId: any) => {
  return await irsSdk.getApplication(sessionId);
};

export enum IDRequestStatus {
  Denied = "denied",
  ApplicationReview = "application review",
  Pending = "pending",
  Approved = "approved",
}
